import { useCallback } from 'react';

import { useCurrentRequirementIndex } from './useCurrentRequirementIndex';
import { useCriteriaRequirementsState } from '../criteria/useCriteriaRequirementsState';
import { useQueryStateContext } from '../../contexts';

export const useRemoveRequirement = () => {
  const { setRequirements } = useCriteriaRequirementsState();
  const { resetQueryId } = useQueryStateContext();
  const index = useCurrentRequirementIndex();
  return useCallback(() => {
    setRequirements((requirements) => requirements.filter((_, i) => i !== index));
    resetQueryId();
  }, [setRequirements, index]);
};
